import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { InputHTMLAttributes, ReactElement, ReactNode } from 'react';
import VoxelIconButton from '../Buttons/VoxelIconButton';
import { } from '@fortawesome/pro-regular-svg-icons';
import { faSearch, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export interface VoxelAdvancedTextSearchProps
  extends Pick<
    InputHTMLAttributes<HTMLInputElement>,
    | 'onChange'
    | 'onClick'
    | 'value'
    | 'placeholder'
    | 'autoFocus'
    | 'disabled'
    | 'maxLength'
    | 'onBlur'
    | 'type'
  > {
  id?: string;
  deleteValue?: () => void;
  size?: 'xs' | 'sm';
  widthClass?: string;
  infoIcon?: ReactElement;
  error?: boolean;
}

const VoxelAdvancedTextSearch: React.FC<VoxelAdvancedTextSearchProps> = ({
  id,
  value,
  onChange,
  onClick,
  placeholder = 'Search',
  autoFocus,
  disabled,
  maxLength,
  deleteValue,
  onBlur,
  size = 'sm',
  widthClass = 'w-full',
  infoIcon,
  type,
  error = false,
}) => {
  // Icon size
  let iconSize: SizeProp | null = null;
  if (size === 'xs') iconSize = 'sm';
  else if (size === 'sm' || size === 'md') iconSize = null;
  else iconSize = 'lg';

  // Icon position
  let searchIconPosition: string = '';
  if (size === 'xs') searchIconPosition = 'left-2.5 top-[4px]';
  else if (size === 'sm') searchIconPosition = 'left-2.5 top-[6px]';
  else searchIconPosition = 'left-3 top-[8px]';

  // Vertical padding
  let verticalPadding: string = 'py-1';
  if (size === 'xs') verticalPadding = 'py-1';
  else if (size === 'sm') verticalPadding = 'py-1.5';

  return (
    <div className={`relative ${widthClass} group flex flex-row items-center flex-nowrap `}>
      <input
        onBlur={onBlur}
        id={id}
        value={value}
        onChange={onChange}
        onClick={onClick}
        placeholder={placeholder}
        autoFocus={autoFocus}
        autoComplete="off"
        spellCheck="false"
        autoCapitalize="off"
        autoCorrect="off"
        disabled={disabled}
        maxLength={maxLength}
        type={type}
        className={`w-full
          pl-10 ${verticalPadding} ${infoIcon ? 'pr-7' : 'pr-2.5'}  
          rounded-md outline-none ring-voxel-gray-300 ring-1
          group-hover:ring-voxel-gray-400 group-hover:ring-1
          focus:ring-primary-600 focus:ring-2 
          group-hover:focus:ring-primary-600 group-hover:focus:ring-2
          disabled:bg-white disabled:ring-white disabled:text-gray-400
      `}
      />
      {/* Search icon  */}
      <div className={`absolute z-2 text-voxel-gray-700 ${searchIconPosition}`}>
        <FontAwesomeIcon
          icon={faSearch}
          size={iconSize}
          className={error ? 'text-red-600' : undefined}
        />
      </div>
      {/* Info icon  */}
      {infoIcon && !value && (
        <div
          className={`
          absolute z-50  
          ${size === 'xs' && 'right-2  top-1'} ${size === 'sm' ? 'right-3 top-1.5' : ''}
          `}
        >
          {infoIcon}
        </div>
      )}
      {/* Delete icon  */}
      {!disabled && deleteValue && !!value && (
        <div
          className={`
          absolute z-50 
          ${size === 'xs' ? 'right-1.5 top-[2px]' : ''} 
          ${size === 'sm' ? 'right-1.5 top-[4px]' : ''} 
          `}
        >
          <VoxelIconButton
            type="button"
            onClick={deleteValue}
            color="white"
            size="xs"
            icon={<FontAwesomeIcon icon={faXmark} />}
          />
        </div>
      )}
    </div>
  );
};

export default VoxelAdvancedTextSearch;
